import { useContext } from 'react'

import { useTrips } from './api/trip'

import TripContext from 'tripPlanner/contexts/TripContext'
import type { UserPermissions } from 'tripPlanner/types/common'
import { getTripPermissions } from 'tripPlanner/utils'

export const useTripPermissions = (tripId?: string): UserPermissions => {
  const tripContext = useContext(TripContext)

  const { isLoading, data: trips } = useTrips({ enabled: !tripContext })

  if (tripContext) {
    return tripContext.permissions
  }

  const trip = trips?.find((trip) => trip.id === tripId)
  if (isLoading) {
    return {
      canEdit: true,
      canAdmin: false,
    }
  }
  if (!trip) {
    return {
      canEdit: false,
      canAdmin: false,
    }
  }

  return getTripPermissions(trip)
}
